@if (bastionKeyBlocked() && authReady()) {
    <app-bastion-key-gate [state]="bastionState() ?? 'none'" [recheckAction]="recheckKey" />
} @else {
    <router-outlet />
}
@if (!isSplashWindow) {
    <pn-toast position="top-right" />
}
@if (!isSplashWindow && authReady()) {
    <app-connectivity-modal
        [isConnecting]="isConnecting() || isRetrying()"
        [hasError]="hasError()"
        [errorMessageKey]="errorMessageKey()"
        (retry)="retry()"
    />
}
